import http from '../plugins/axios'

export const getAllLanguagesList = async (params) => {
  try {
    const response = await http.get(`/api/v2/languages`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const createLanguage = async (payload) => {
  try {
    const response = await http.post(`/api/v2/languages`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateLanguage = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/languages/${id}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteLanguage = async (id) => {
  try {
    const response = await http.delete(`/api/v2/languages/${id}`)
    return response.data
  } catch(error) {
    throw error
  }
}
